import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

export default class BudgetForecastUserModel extends Model {
  [Type] = 'budget-forecast/user' as const;

  @attr('string') declare email: string;
  @attr('string') declare name: string;
}
